import PropTypes from 'prop-types'
import React from 'react'
import pic01 from '../images/pic01.jpg'
import pic02 from '../images/pic02.jpg'
import pic03 from '../images/pic03.jpg'

class Main extends React.Component {
  render() {
    let close = (
      <div
        className="close"
        onClick={() => {
          this.props.onCloseArticle()
        }}
      ></div>
    )

    return (
      <div
        ref={this.props.setWrapperRef}
        id="main"
        style={this.props.timeout ? { display: 'flex' } : { display: 'none' }}
      >
        <article
          id="intro"
          className={`${this.props.article === 'intro' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Intro</h2>
          <span className="image main">
            <img src={pic01} alt="" />
          </span>
          <p>
            We are a technology company who specializes in working with small and
            medium sized companies with big vision. What started as a hobby initiative,
            is now a registered consulting organization.
          </p>
          <p>
            We believe that every startup with a right team is bound to succeed.
            Working with startups and seeing them go-to-market with their products gives us immense pleasure.
            We are all ears to your new startup idea, whichever stage it is in.. :)

          </p>
          {close}
        </article>

        <article
          id="work"
          className={`${this.props.article === 'work' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Services</h2>
          <span className="image main">
            <img src={pic02} alt="" />
          </span>
          <p>
            Our specialities include:
            <br />ERP/CRM, ECommerce, Landing Pages, Social Media Marketing, QA and Devops
            <br /><br />
            Our ERP/CRM experitise spans: <ul>
              <li>Oracle JD Edwards EnterpriseOne</li>
              <li>Microsoft Dynamics GP, Dynamics Business Central, D365, Dynamics CRM</li>
              <li>Salesforce</li>
              <li>SAP ECC</li>
              <li>Oracle X Store PoS</li>
              </ul>
          We can take care of implementation, testing, UAT, post go-live support and maintenance.
          We are a <b>Shopify partner</b> and can help you setup your ecommerce store
          </p>
          <p>
            If you are a startup with a small team who wants to ship quality code,we can help you with:
            <ul><li>Adhoc Testing Cycles</li>
            <li>Manual, automation, and performance testing</li>
            <li>Setup and Bootstrap a self-service Devops strategy</li></ul>

          Apart from this, we also help in other areas like:
          <ul><li>Design and build Landing pages for companies and individuals</li>
          <li>Social media marketing</li>
          <li>HR and Onboarding support for companies</li>
          <li>Help in establishing canadian entities for overseas organizations.</li></ul>
          </p>
          {close}
        </article>

        <article
          id="about"
          className={`${this.props.article === 'about' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">About</h2>
          <span className="image main">
            <img src={pic03} alt="" />
          </span>
          <p>
            Lorem ipsum dolor sit amet, consectetur et adipiscing elit. Praesent
            eleifend dignissim arcu, at eleifend sapien imperdiet ac. Aliquam
            erat volutpat. Praesent urna nisi, fringila lorem et vehicula
            lacinia quam. Integer sollicitudin mauris nec lorem luctus ultrices.
            Aliquam libero et malesuada fames ac ante ipsum primis in faucibus.
            Cras viverra ligula sit amet ex mollis mattis lorem ipsum dolor sit
            amet.
          </p>
          {close}
        </article>

        <article
          id="contact"
          className={`${this.props.article === 'contact' ? 'active' : ''} ${
            this.props.articleTimeout ? 'timeout' : ''
          }`}
          style={{ display: 'none' }}
        >
          <h2 className="major">Let's Talk!</h2>
          <p> Wanna show a cool product?! <br/>Do you want a landing page for yourself? <br/>
          Do you want to know more about services? < br/>
          Or do you just want to say hi! </p>
          <a href="https://calendly.com/tejas-tech-contact">Schedule time with me</a>
        </article>
        
              </div>
    )
  }
}

Main.propTypes = {
  route: PropTypes.object,
  article: PropTypes.string,
  articleTimeout: PropTypes.bool,
  onCloseArticle: PropTypes.func,
  timeout: PropTypes.bool,
  setWrapperRef: PropTypes.func.isRequired,
}

export default Main
